export interface UserCategoryType {
  userCategoryTypeID: number;
  userCategoryTypeName: string;
  userCategoryTypeBC: string;
  isActive: boolean;
}

export enum UserCategoryTypeBC {
  Client = 'CLIENT',
  Passenger = 'PASSENGER',
  Driver = 'DRIVER',
  TransportationProvider = 'TRANSPORTATIONPROVIDER',
  ServiceAccount = 'SERVICEACCOUNT',
  Internal = 'INTERNAL',
}
